<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
    </el-form-item>
    <div class="clear-fix">
      <span
        v-if="tempQuesData.referFlag"
        class="addOtherBotton quoteOption bottom10 matrixPart"
      >此题选项来源于第 {{tempQuesData.referIndex}} 题中的选中项</span>
      <div v-else class="matrixPart">
        <p class="matrix-tips">问题设置（纵轴）</p>
        <el-form
          :rules="optRule"
          v-for="(title, index) in tempQuesData.subTitles"
          label-width="80px"
          :model="title"
          :key="index"
        >
          <el-form-item prop="text" :label="'问题' + (index + 1)">
            <el-input class="matrix-input" v-model="title.text" :id="'opt_' + title.id"></el-input>
            <i
              class="el-icon-close"
              @click="deleteOption(tempQuesData, tempQuesData.subTitles, index)"
            ></i>
          </el-form-item>
        </el-form>
        <div
          class="addOptionBtn addMatrixOptionBtn"
          @click="addSubTitles(tempQuesData.subTitles)"
        >新建问题</div>
        <el-button type="text" @click="handleTitleBatchChange">批量修改</el-button>
      </div>
      <div class="matrixPart">
        <p class="matrix-tips">打分设置（横轴）</p>
        <el-form-item label="打分类型">
          <el-select class="maxSelectInput" v-model="tempQuesData.starType">
            <el-option label="满意度" :value="0"></el-option>
            <el-option label="认同度" :value="1"></el-option>
            <el-option label="重要度" :value="2"></el-option>
            <el-option label="愿意度" :value="3"></el-option>
            <el-option label="符合度" :value="4"></el-option>
            <el-option label="自定义" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="customInput" v-if="tempQuesData.starType == 5">
          <el-input type="text" v-model="tempQuesData.starShowCustomStart"></el-input>-
          <el-input type="text" v-model="tempQuesData.starShowCustomEnd"></el-input>
        </el-form-item>
        <el-form-item label="打分范围">
          <el-input-number class="starRangeInput" v-model="tempQuesData.starNum" :min="1" :max="11"></el-input-number>
        </el-form-item>
        <el-form-item label="起始数值">
          <el-input-number
            class="starRangeInput"
            v-model="tempQuesData.starBeginNum"
            :min="0"
            :max="10"
          ></el-input-number>
        </el-form-item>
      </div>
    </div>
    <el-collapse
      v-model="advancedSetting"
      @change="handleSettingChange"
      class="batchChange backgroundGray"
    >
      <el-collapse-item name="1">
        <template slot="title">
          <div class="advanced-setting-title backgroundGray">
            <span class="more-setting-btn">
              {{advancedSettingTitle}}
              <i :class="advanceSettingIcon"></i>
            </span>
          </div>
        </template>
        <div class="backgroundGray">
          <div class="edit-settings">
            <el-checkbox v-model="tempQuesData.referFlag">问题引用</el-checkbox>
            <el-select
              size="mini"
              v-show="tempQuesData.referFlag"
              v-model="tempQuesData.refer"
              @change="handleReferChange"
              :class="{errorTooltip:(!tempQuesData.refer && tempQuesData.referFlag)}"
            >
              <el-option
                v-for="(checkbox, idx) in checkboxs"
                :label="(checkbox.realIndex + 1) + '.' + checkbox.title"
                :value="checkbox.id"
                :key="idx"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <span v-if="ques.referFlag">此题子问题来源于第 {{ques.referIndex}} 题中的选中项</span>
    <div v-else class="matrix-starRadios matrix-disp">
      <p class="matrix-star-text">
        <span
          class="matrix-starText"
        >{{ ques.starType !== 5 ? '非常不' + starMap[ques.starType] : ques.starShowCustomStart }}</span>
        <span
          class="matrix-starText"
        >{{ ques.starType !== 5 ? '非常' + starMap[ques.starType] : ques.starShowCustomEnd }}</span>
      </p>
      <div class="matrix-star-sub" v-for="(item, index) in ques.subTitles" :key="index">
        <div class="star-sub-title pull-left">{{ item.text }}</div>
        <el-slider
          class="silder-star"
          v-model="item.checkedStar"
          :step="1"
          show-stops
          :min="ques.starBeginNum"
          :max="ques.starNum + ques.starBeginNum - 1"
        ></el-slider>
      </div>
    </div>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
import { uuid } from "../utils/utils";
import { quesMixin } from '../utils/mixins'
export default {
  name: "matrix-radio",
  mixins: [quesMixin],
  data() {
    return {
      starMap: ["满意", "认同", "重要", "愿意", "符合"],
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "checkboxs", "survey", "config"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleTitleBatchChange() {
      this.$emit("batchChange", this.tempQuesData.subTitles, "subTitles");
    },
    addSubTitles(title) {
      title.push({
        id: uuid(),
        text: "",
        checkedStar: -1
      });
      this.$nextTick(() => {
        let _opt = document.getElementById("opt_" + title[title.length - 1].id);
        _opt && _opt.focus();
        _opt = null;
      });
    },
    deleteOption(ques, arr, idx) {
      if (arr[idx].id === "98") ques.blankSetting = [];
      arr.splice(idx, 1);
    },
    handleReferChange(refer) {
      let _ = this;
      let pages = _.survey.pages;
      _.tempQuesData.subTitles = [];
      for (let i = 0; i < pages.length; i++) {
        pages[i].questions.forEach(item => {
          let { id, index, title, type, options } = item;
          if (type === "checkbox" && id === refer) {
            options.forEach(val => {
              _.tempQuesData.subTitles.push({
                id: val.id,
                text: val.text,
                checkedStar: -1
              });
            });
            _.tempQuesData.referIndex = index + 1;
          }
        });
      }
    },
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.matrixPart {
  &:last-child {
    .el-form-item {
      width: 60%;
      margin: 0 auto 20px;
    }
  }
  .maxSelectInput {
    width: 120px;
  }
}
.matrix-star-text {
  padding-left: 100px;
  overflow: hidden;
  height: 26px;
  position: relative;
  .matrix-starText {
    position: absolute;
    font-size: 12px;
    left: 150px;
    &:last-child {
      right: 0;
      left: auto;
    }
  }
}
.matrix-star-sub {
  min-height: 40px;
  overflow: hidden;
}
.star-sub-title {
  width: 150px;
  min-height: 40px;
  line-height: 20px;
  word-break: break-all;
  text-align: left;
  padding-bottom: 10px;
  padding-top: 10px;
}
.silder-star {
  float: left;
  width: calc(100% - 150px);
}
</style>



// WEBPACK FOOTER //
// src/components/matrix-star.vue